import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ClockInState } from '@/store/clockIn/types';
import state from './state';
import mutations from './mutations';
import actions from './actions';

const Tutors: Module<ClockInState, RootState> = {
  state,
  mutations,
  actions,
};

export default Tutors;
